import React from 'react';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div>
        <h1>404</h1>
        <h2>PAGE NOT FOUND</h2>
        <p>The Page You Requested Could Not Be Found</p>
      </div>
    </div>
  );
};

export default NotFound;